<h1 mat-dialog-title>Atualizando {{ data.title }}</h1>
<form [formGroup]="fileForm" (ngSubmit)="onSubmitFile()" class="mt-5">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <div class="tagus-form-group mb-12">
          <app-input-file-upload
            formControlName="file"
            [progress]="progressFilesUpload"
          ></app-input-file-upload>
          <mat-error *ngIf="hasErrorFile('file', 'required')"
            >{{ data.description }} é obrigatório</mat-error
          >
          <mat-error *ngIf="hasErrorFile('file', 'requiredFileType')"
            >Tipo de arquivos permitidos: Imagens e PDF</mat-error
          >
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()">Cancelar</button>
    <button type="submit" mat-button [disabled]="!fileForm.valid">
      Atualizar
    </button>
  </div>
</form>
